import { render } from "./AddUserNote.vue?vue&type=template&id=50b7816e&scoped=true"
import script from "./AddUserNote.vue?vue&type=script&lang=js"
export * from "./AddUserNote.vue?vue&type=script&lang=js"

import "./AddUserNote.vue?vue&type=style&index=0&id=50b7816e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b7816e"]])

export default __exports__